import React from 'react';
import { Pill, PillStatus } from '../ui';
import { PartNumberCheckView } from './partNumberCheck';

/**
 * Whether the supplier's listing is the BOM line's exact part. A different part
 * number is a warning, never hidden: the listing stays visible, ranked below the
 * rest, so the buyer sees what research found and why it is not a pick.
 */
const LOOK: Record<PartNumberCheckView['status'], { status: PillStatus; title: string }> = {
  match: { status: 'success', title: "The supplier's listing shows the part number on your BOM" },
  mismatch: { status: 'warn', title: 'This listing is for a different part number than the one on your BOM' },
  unverified: { status: 'neutral', title: "The supplier's listing does not show a part number to compare" },
};

const labelOf = (check: PartNumberCheckView): string => {
  if (check.status === 'match') return 'Part number matches';
  if (check.status === 'mismatch') {
    return check.listedPartNumber ? `Different part number: ${check.listedPartNumber}` : 'Different part number';
  }
  return 'Part number not shown';
};

export const PartNumberChip: React.FC<{ check?: PartNumberCheckView; className?: string }> = ({ check, className = '' }) => {
  if (!check) return null;
  const look = LOOK[check.status];
  return (
    <span title={look.title} className={`inline-flex shrink-0 ${className}`}>
      <Pill status={look.status} className="whitespace-nowrap">
        {labelOf(check)}
      </Pill>
    </span>
  );
};

export default PartNumberChip;
